export default {
  test: "en test",
  topbar: {
    ownerTitle: "Owner?",
    addMyPlace: "Add my place",
    loginSignup: "Log in/Sign up",
    myPlaces: "My places",
    myAccount: "My account",
    logout: "Logout",
    welcome: "Welcome { username }",
    whyJoinLabel: "Why join Maïka?",
    whyJoinURL: "https://maika.coffee/why-join-network.html",
    tryAppLabel: "Try the App!",
  },
  login: {
    onlyOnwer: "** Space for establishment owners only **",
    backToMaika: "Back to Maïka",
    email: "Email address",
    password: "Password",
    login: "Log in",
    forgotPassword: "I forgot my password",
    newToApp: "New to Maïka?",
    signup: "Sign me up!",
    passwordShort: "Password must be at least 8 characters long",
    fieldsMandatory: "All fields are mandatory",
  },
  signup: {
    onlyOnwer: "** Space for establishment owners only **",
    backToMaika: "Back to Maïka",
    signup: "Sign up",
    email: "Email address",
    password: "Password",
    login: "Log me in!",
    agreeTo: "Agree to",
    conditions: " terms and conditions",
    and: " and ",
    privacy: "privacy policy",
    alreadyRegistred: "Already have a Maïka account?",
    passwordShort: "Password must be at least 8 characters long",
    accountCreated:
      "Your account has been created! You'll soon receive an email to end the creation process",
    fieldsMandatory: "All fields are mandatory",
  },
  home: {
    myPlacesTitle: "My places",
    addPlaceBtn: "Add a place",
    pendingVerification:
      "An email has been sent. Please click on the link to verify your account.",
  },
  placeRow: {
    verifiedLabel: "Verified!",
    notVerifiedLabel:
      "Not verified - make your café visible to { users } persons by verifying it!",
    beingReviewed:
      "The place is being reviewed. You'll receive an email as soon as it's verified!",
    wasStopped:
      "You canceled your subscription. Go to the place's details to resume it",
    nextPaymentDate: "Next payment planned on { paymentDate }",
    openDetailsBtn: "See details",
    pdfBtn: "Download last invoice",
    seeDetailsLink: "See place's details",
    verifyBtn: "Verify this place",
  },
  placeDetail: {
    stopRenew: "Stop renew",
    backToPlaces: "Back to my places",
    verification: {
      title: "Place verification",
      howLink: "How verifying my place will improve my business?",
      documentNeededTitle:
        "In the order to verify your place, you will need to upload:",
      documentNeededOne:
        "• A document proving you're the owner of the place (with your name and your place name on it)",
      documentNeededTwo:
        "• A document proving your establishment has a wifi connection (your provider invoice will be fine)",
      plans: {
        planTitle: "Select your plan",
        monthlyTitle: "Monthly plan",
        yearlyTitle: "Yearly plan",
        monthLabel: "month",
        yearLabel: "year",
        selectButton: "Select this option",
        monthlyDescription: {
          first: "• Shown as verified place on the app",
          second: "• Be more visible to more than { users } remote workers",
          third: "• Will have access to future features",
          fourth: "• Part of the Maïka network",
        },
        yearlyDescription: {
          first: "• All monthly plan advantages",
          second: "• With 2 months free",
          third: "",
        },
      },
      documents: {
        title: "Upload your documents",
        docIdentity: "Document proving you own the establishment",
        docWifi: "Document proving your establishment provides WiFi",
        errors: {
          fileTooBig: "File size cannot exceed 3MB",
          wrongFileType: "File must be a pdf or an image",
        },
      },
      form: {
        title: "Informations",
        furtherInformationLabel: "Any information you want to add?",
        vatNumberLabel: "VAT Number",
      },
      payment: {
        title: "Proceed payment",
        furtherInformationLabel: "Any information you want to add?",
        vatNumberLabel: "VAT Number",
        paymentBtn: "Proceed payment",
        secureLabel: "Payment secured with Stripe",
        incompleteForm:
          "Please select a plan and upload the required documents",
      },
    },
  },
  paymentSuccess: {
    firstSentence: "Thanks you for your payment!",
    secondSentence:
      "You'll receive an email as soon as your documents have been reviewed!",
    goBackBtn: "Go back to home page",
  },
  accountVerification: {
    endMessage:
      "To end your account verification, please fill in the following informations",
    form: {
      firstname: "Firstname",
      lastname: "Lastname",
      address: "Company address",
      sendForm: "Send form",
      successMessage:
        "Your account has been verified! You'll soon be logged in!",
    },
  },
  accountDetail: {
    hello: "Hello",
    backToHome: "Back to home page",
    fetchError: "An error occurred. Please try again later.",
    manageSubBtn: "Manage subscriptions",
    showInvoicesBtn: "Show invoices",
    contactBtn: "Contact us",
    invoiceNumber: "Invoice N°",
    seeInvoiceDetails: "Go to invoice",
    paidOn: "Paid on",
  },
  verifiedPlace: {
    manageSubscription: "Manage subscription",
    monthlyPlanLabel: "Montly plan",
    yearlyPlanLabel: "Yeary plan",
    nextRenew: "Next payment planned on: ",
    wasStopped:
      "Your canceled your subscription. You can resume it by clicking on 'Manage subscription'",
    price: "Price: ",
  },
  addPlace: {
    title: "Add your place",
    searchLabel: "search here or click on map",
    searchButton: "Search",
    confirmPlace: "I own this place",
    confirmPlaceAlert:
      "A document proving you own this place could be asked at any time",
    alreadyAddedAlert:
      "This place has already been added. If it's yours, please",
    contactUs: "contact us",
    addedSuccess: "Place added with success! You can go back to",
    addedSuccessLink: "your homepage",
    addButton: "Add this place",
  },
  errors: {
    general: {
      generalError: "An error occurred",
    },
    login: {
      incorrectPwd: "Incorrect password",
      notExists: "Email incorrect or inexisting account",
    },
    signup: {
      alreadyRegistred: "This email address is already registered",
    },
    accountVerification: {
      formIncomplete: "All fields with '*' are mandatory",
    },
  },
};
